import { useDocOnce } from '@rainbow-modules/firebase-hooks';
import { isEmpty } from '@rainbow-modules/validation';
import { Container, SectionHeader, StyledTagsList } from './styled';

interface ConversationTopicsProps {
    sessionId: string;
}

const ConversationTopics = ({
    sessionId,
}: ConversationTopicsProps) => {
    const [data, isLoading] = useDocOnce({
        path: `/session/${sessionId}/metadata/postcall`,
        flat: true,
    });

    if (!isLoading && isEmpty(data?.metadata?.topics)) return null;

    const topics = (data?.metadata?.topics ?? []).map(
        ({ topic }: Record<string, unknown>) => topic,
    );

    return (
        <Container>
            <SectionHeader>Topics</SectionHeader>
            <StyledTagsList tags={topics} align="left" />
        </Container>
    );
};

export default ConversationTopics;
